export default function dropdown() {
  jQuery(function ($) {
    $("ul.dropdown-menu li.menu-item-has-children > a").attr("data-toggle", "dropdown");
    $("ul.dropdown-menu li.menu-item-has-children > a").addClass("dropdown-toggle");

    $("ul.dropdown-menu [data-toggle='dropdown']").on("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      $(this).parents(".dropdown").siblings().find(".show").removeClass("show");

      $(this).siblings().toggleClass("show");

      //collapse all after nav is closed
      $(this)
        .parents("li.nav-item.dropdown.show")
        .on("hidden.bs.dropdown", function (e) {
          $(".dropdown-menu .show").removeClass("show");
        });
    });
  });
}
